import { render, staticRenderFns } from "./AccumulationTable.vue?vue&type=template&id=ef84d720&scoped=true"
import script from "./AccumulationTable.vue?vue&type=script&lang=js"
export * from "./AccumulationTable.vue?vue&type=script&lang=js"
import style0 from "./AccumulationTable.vue?vue&type=style&index=0&id=ef84d720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef84d720",
  null
  
)

export default component.exports